import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { CartProvider } from "./cart/CartProvider";
import { ErrorBoundary } from "./ErrorBoundary";
import { I18nProvider } from "./i18n/I18nProvider";
import { CatalogProvider } from "./lib/CatalogProvider";
import { InboxProvider } from "./market/InboxProvider";
import { installErrorReporting } from "./lib/reportError";
import { registerServiceWorker } from "./lib/registerSW";
import "./styles.css";

installErrorReporting();
registerServiceWorker();

const root = document.getElementById("root");
if (!root) throw new Error("#root element missing");

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <I18nProvider>
          <AuthProvider>
            <CatalogProvider>
              <CartProvider>
                <InboxProvider>
                  <App />
                </InboxProvider>
              </CartProvider>
            </CatalogProvider>
          </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
